export default { sha: 'b5d978c9ae4eecbf70033e94617e2744a7e3ac48', buildNumber: 'undefined' }
